import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../constants";
import Box from "../Box/Box";
import { useMedias } from "../hooks/useMedia";
import SnapshotActivity from "./SnapshotActivity";

const COMPONENTS = {snapshot: SnapshotActivity};

const ListingDetails = ({
  id,
  isAuthenticated,
  onSignUp,
  isCompleted,
  completedCount,
  canCompleteMultipleTimes,
  earned,
  viewYourReceipt,
  type,
  refresh,
  getDetails,
}) => {
  const props = {
    id,
    isAuthenticated,
    onSignUp,
    isCompleted,
    completedCount,
    canCompleteMultipleTimes,
    earned,
    viewYourReceipt,
    type,
    refresh,
    getDetails,
  };

  const Klass = COMPONENTS[type] || React.Fragment;

  return (
    <Wrapper bgColor="#ecefec" spacing="p-5 pt-7" sm-spacing="p-4+1 pt-6+2">
      <Box bgColor="#fff" spacing="p-5" borderRadius="12px">
        <Klass {...props} />
      </Box>
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  border-radius: 12px;
  margin-top: -24px;
  z-index: -1;

  @media ${breakpoints.mobile} {
    border-radius: 0;
  }
`;

ListingDetails.defaultProps = {
  reward: 0,
};

export default ListingDetails;